import { createFileRoute } from "@tanstack/react-router";

import { useMe } from "../features/auth/session";
import { CampaignDetailPage } from "../features/campaigns/CampaignDetailPage";
import { useT } from "../i18n/I18nProvider";

export const Route = createFileRoute("/app/campaigns/$campaignId/")({
  component: OverviewRoute,
});

function OverviewRoute() {
  const t = useT();
  const me = useMe();
  const { campaignId } = Route.useParams();
  if (!me.data) return <p>{t("common.loading")}</p>;
  return <CampaignDetailPage me={me.data} campaignId={campaignId} />;
}
